var _path, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReelMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 339,
    viewBox: "0 0 195 339",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.58172 0 0 3.58171 0 7.99999V72H195V8C195 3.58172 191.418 0 187 0H8ZM195 267H0V331C0 335.418 3.58172 339 8 339H187C191.418 339 195 335.418 195 331V267Z",
    fill: "black",
    fillOpacity: 0.4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 72.5,
    width: 194,
    height: 194,
    stroke: "#FAFAFA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReelMask);
export default __webpack_public_path__ + "static/media/reelMask.d517c6e5.svg";
export { ForwardRef as ReactComponent };